/** Filtro local da grade de vínculos de contas (todas as colunas visíveis). */

export function aplicarFiltroBancoFiltros(lista, termo) {
  const t = String(termo ?? "").trim().toLowerCase();
  if (!t) return lista ?? [];

  return (lista ?? []).filter((row) => {
    if (!row || typeof row !== "object") return false;

    const campos = [
      row.filtro,
      row.descricao,
      row.banco_label,
      row.codigo_banco,
      row.cnpjs_label,
      row.conta_dominio_label,
      row.conta_protheus_label,
      row.usuario_label,
      ...(Array.isArray(row.cnpjs) ? row.cnpjs : []),
    ];

    return campos.some((valor) =>
      String(valor ?? "")
        .toLowerCase()
        .includes(t)
    );
  });
}
